export const displayTeamHandicap = (team, tournament) => {
  if (!tournament?.handicapScoring) {
    return "";
  } else if (tournament?.numberOfPlayers === 1) {
    return displayPlayerHandicap(team?.players?.[0], tournament);
  }

  let handicap = "";
  if (team?.handicap === undefined || team?.handicap === null) {
    if (tournament?.usePlayerAverageHandicap) {
      handicap = `(${formatHandicap(team?.playersHandicapAverage)}`;
    } else {
      handicap = "(0";
    }
    if (hasAdjustedHandicap(tournament)) {
      handicap += `/${formatHandicap(team?.adjustedHandicap)} ADJ`;
      if (tournament?.usePlayerAverageHandicap) {
        handicap += ")";
      } else {
        handicap += " - No HDCP)";
      }
    } else {
      handicap += " - No HDCP)";
    }
  } else {
    if (hasAdjustedHandicap(tournament)) {
      handicap = `(${formatHandicap(team?.handicap)}/${formatHandicap(team?.adjustedHandicap)} ADJ)`;
    } else {
      handicap = `(${formatHandicap(team?.adjustedHandicap)})`;
    }
  }

  return handicap;
};

export const displayPlayerHandicap = (player, tournament) => {
  if (!tournament?.handicapScoring) {
    return "";
  }

  let handicap = "";
  if (player?.handicap !== undefined && player?.handicap !== null) {
    const hCap = formatHandicap(player?.handicap);
    if (hCap !== "") {
      handicap = `(${hCap}`;
      if (hasAdjustedHandicap(tournament)) {
        handicap += `/${formatHandicap(player?.adjustedHandicap)} ADJ)`;
      } else {
        handicap += ")";
      }
    }
  } else if (player?.ghinHandicap !== undefined && player?.ghinHandicap !== null) {
    const hCap = formatHandicap(player?.ghinHandicap);
    if (hCap !== "") {
      handicap = `(${hCap}`;
      if (hasAdjustedHandicap(tournament)) {
        handicap += `/${formatHandicap(player?.adjustedHandicap)} ADJ - GHIN)`;
      } else {
        handicap += " - GHIN)";
      }
    }
  } else {
    handicap = "(0";
    if (hasAdjustedHandicap(tournament)) {
      handicap += `/${formatHandicap(player?.adjustedHandicap)} ADJ - No HDCP)`;
    } else {
      handicap += " - No HDCP)";
    }
  }

  return handicap;
};

const formatHandicap = (handicap) => {
  const value = parseFloat(handicap);
  const isInteger = Number.isInteger(value);
  if (isNaN(value)) {
    return "";
  } else {
    if (value >= 0.0) {
      return `${isInteger ? value : value.toFixed(1)}`;
    } else {
      return `+${isInteger ? Math.abs(value) : Math.abs(value).toFixed(1)}`;
    }
  }
};

const hasAdjustedHandicap = (tournament) => {
  return tournament?.handicapPercentage < 100 || tournament?.handicappingType !== "none" || tournament?.usePlayerAverageHandicap;
};
